import React from 'react'
import FlexboxChallenge from './FlexboxChallenge'

export default class extends React.Component {
  render() {
    const literalStyles = `
      .no-cheating, .flexbox-challenge {
        height: 500px;
      }

      .no-cheating > *, .flexbox-challenge > *{
        margin: 10px;
        width: 200px;
      }

      .no-cheating {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
      }

      .no-cheating > *:nth-of-type(2) {
        height: 25%;
        align-self: center;
      }

      .no-cheating > *:nth-of-type(3) {
        height: 50%;
        align-self: flex-end;
      }

      .flexbox-challenge {
        display: flex;
        flex-direction: AAAHHHFFFMMM;
        justify-content: SMMMMMAAAAAG;
      }

      .flexbox-challenge > *:nth-of-type(2) {
        height: 25%;
        align-self: BLUURRGGGG;
      }
      
      .flexbox-challenge > *:nth-of-type(3) {
        height: 50%;
        align-self: SLUURRGGGG;
      }
    `

    return (
      <FlexboxChallenge
        title="Flexbox Devtools Challenge"
        description="Fix the Flexbox layout using just the devtools!"
        literalStyles={literalStyles}
        nextChallenge={5}
        infected={[2, 3]}
      >
        <div />
        <div />
        <div />
        <div />
      </FlexboxChallenge>
    )
  }
}
